import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const REGISTER_CLASS_NAME = 'Register';
export const REGISTER_CLASS_SLOTS = ['root'] as const;

export type RegisterClassSlot = typeof REGISTER_CLASS_SLOTS[number];

export interface RegisterClasses {
	root: string;
}

export type RegisterClassKey = keyof RegisterClasses;

export const getRegisterUtilityClass = (slot: string) =>
	generateUtilityClass(REGISTER_CLASS_NAME, slot);

export const registerClasses = generateUtilityClasses<keyof RegisterClasses>(
	REGISTER_CLASS_NAME,
	['root'],
);
export default registerClasses;
